import React, { useState } from 'react';
import { useAuth } from '../../store/authContext';
import { LockIcon } from '../../utils/icons';
import ChangePasswordModal from '../../components/ChangePasswordModal';
import './Profile.css';

export default function Profile() {
  const { user, logout } = useAuth();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const isOrgUser = user?.role && user.role !== 'super_admin';

  const formatRole = (role) => {
    if (!role) return '';
    return role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <div className="pf-page">
      <div className="page-header animate-fade-up">
        <div>
          <p className="section-label" style={{ marginBottom: 4 }}>Account</p>
          <h1 className="page-title">Profile</h1>
        </div>
      </div>

      {/* User Info Card */}
      <div className="pf-card card animate-fade-up" style={{ animationDelay: '40ms' }}>
        <div className="pf-user-header">
          <div className="pf-avatar">
            {user?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="pf-user-info">
            <h2 className="pf-user-name">{user?.name || 'User'}</h2>
            <p className="pf-user-role">{formatRole(user?.role)}</p>
          </div>
        </div>

        <div className="pf-details">
          <div className="pf-detail-row">
            <span className="pf-detail-label">Email</span>
            <span className="pf-detail-value">{user?.email || '—'}</span>
          </div>
          {user?.tenantName && (
            <div className="pf-detail-row">
              <span className="pf-detail-label">Organisation</span>
              <span className="pf-detail-value">{user.tenantName}</span>
            </div>
          )}
        </div>
      </div>

      {/* Actions Card */}
      <div className="pf-card card animate-fade-up" style={{ animationDelay: '80ms' }}>
        <h3 className="pf-card-title">Actions</h3>
        <div className="pf-actions">
          {isOrgUser && (
            <button
              className="btn btn-ghost pf-action-btn"
              onClick={() => setShowChangePassword(true)}
            >
              <LockIcon size={14} />
              Change Password
            </button>
          )}
          <button className="btn btn-danger pf-action-btn" onClick={logout}>
            <LogoutIcon size={14} />
            Sign Out
          </button>
        </div>
      </div>

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  );
}

function LogoutIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M6 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M10.5 11L14 8l-3.5-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 8H6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
}
